import { useEffect, useState } from 'react';
import { isChrome, isFirefox } from '~/scripts/extension';
type BrowserName = 'Chrome' | 'Firefox' | '';
export default function useGetBrowserName() {
  const [browserName, setBrowserName] = useState<BrowserName>('');
  useEffect(() => {
    if (isChrome()) {
      setBrowserName('Chrome');
    } else if (isFirefox()) {
      setBrowserName('Firefox');
    } else {
      setBrowserName('');
    }
  }, []);
  return browserName;
}
